import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ValidatorFn,
  FormControl,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  faChevronRight,
  faChevronLeft,
} from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from '../../_alert';
import { AppConfig } from '../../app.config';
import { DatastoreService } from '../../services/datastore.service';
import { AmazonService } from '../../services/jrni/amazon.service';
import { ApiService } from '../../services/jrni/api.service';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { BasketService } from '../../services/jrni/basket.service';
import { DepartmentService } from '../../services/jrni/department.service';
import { MemberService } from '../../services/jrni/member.service';
import { ServicesService } from '../../services/jrni/services.service';
import { environment } from '../../../environments/environment';
import { AddressLookupStatusComponent } from '@bookinglab/hwrc-ui';

export class BlFormControl extends FormControl {
  alwaysDisabled: boolean;
}

@Component({
  selector: 'app-permits',
  templateUrl: './permits.component.html',
  styleUrls: ['./permits.component.scss'],
})
export class PermitsComponent implements OnInit {
  parentDepartment;
  selectedDepartment;
  selectedService;
  pageTitle: string;
  guidanceMsg: string;
  dataPolicy: string;
  declaration_question_override: string;
  bookingDetailsPageText: string;
  permitQuestions = [];
  submitted: boolean;
  selectedLocation;
  requiresFullRegistration = false;
  organisationQuestions = [];
  today = new Date();
  selectedFile: string;
  subtmitButtonDisabled: boolean;
  public dvlaLookupQuestionMap = AppConfig.settings.dvlaLookupQuestionMap;
  vehicleStatus: any = 0;
  addressFoundBefore = false;
  member;
  slot;
  banned = false;
  customerQuestions;
  unavailableTimes = [];
  // https://regexr.com/3pp3r <- Postcode validator
  postcodeValidator =
    '^(([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))s?[0-9][A-Za-z]{2}))$';
  addresses = [];
  showingAddresses = [];
  isInLocalArea = [];
  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;
  selectedAddressId;
  custodian_codes = [3455];
  showWasteWarning: boolean = false;
  wasteLimit: any = {};
  wasteUnits: string = 'litres';
  permitQuestion = AppConfig.settings.permitQuestion.toString();
  uploadQuestionFiles = [];
  uploadQuestionIds = [];
  permitQuestionsForm;
  addressUsed: any = false;
  registrationUsed: any = false;
  localAreaId: any;
  motStatusInvalid: boolean;
  taxStatusInvalid: boolean;

  constructor(
    private router: Router,
    private servicesService: ServicesService,
    private departmentService: DepartmentService,
    private formBuilder: FormBuilder,
    private basketservice: BasketService,
    private alertService: AlertService,
    private translateService: TranslateService,
    private memberService: MemberService,
    public datastoreService: DatastoreService,
    private spinner: NgxSpinnerService,
    private apiService: ApiService,
    public addressLookupStatusComponent: AddressLookupStatusComponent,
    private amazonService: AmazonService,
    private availabilityService: AvailabilityService
  ) {
    console.log('this.datastoreService.config', this.datastoreService.config);
  }

  // Initialise the customer form

  addressEnabled = AppConfig.settings.addressApi.enabled;

  matchingEmailsValidator(
    emailKey: string,
    confirmEmailKey: string
  ): ValidatorFn {
    return (group: FormGroup): { [key: string]: any } => {
      let email = group.controls[emailKey];
      let confirmEmail = group.controls[confirmEmailKey];
      // If the email and confirm email inputs have data
      if (email.value.length > 0 && confirmEmail.value.length > 0) {
        // Check if the emails match
        if (email.value.toLowerCase() !== confirmEmail.value.toLowerCase()) {
          confirmEmail.setErrors({ mismatch: true });
          return {
            mismatch: true,
          };
        } else if (confirmEmail.errors && confirmEmail.errors.mismatch) {
          // If the errors object does not contain any other errors then set errors {} to null
          if (Object.keys(confirmEmail.errors).length == 1) {
            confirmEmail.setErrors(null);
          } else {
            // Delete the mismatch error from the object as we do not want to remove any other errors that exist in the {}
            delete confirmEmail.errors.mismatch;
          }
        } else {
          confirmEmail.setErrors(null);
          return null;
        }
      }
    };
  }

  get bookingForm() {
    return this.permitQuestionsForm.controls;
  }

  getAlwaysDisabled(ctrlName: string): boolean {
    return (this.permitQuestionsForm.get(ctrlName) as BlFormControl)
      .alwaysDisabled;
  }

  routerGoBack() {
    this.router.navigate(['/services']);
  }

  restartJourney() {
    this.router.navigate(['/departments']);
  }

  checkAddress(addr: any, id: any) {
    if (id === "registered_keeper_postcode") {
      return true // override for specific permit question
    }
    const matchingCodes = this.custodian_codes.filter((code) => {
      if (addr.LOCAL_CUSTODIAN_CODE === code) {
        return true;
      }
    });
    if (matchingCodes.length > 0) return true;
    else return false;
  }

  async getVehicle() {
    this.spinner.show();
    this.registrationUsed = false
    // this.motStatusInvalid = false
    // this.taxStatusInvalid = false
    console.log(this.permitQuestionsForm);
    console.log(this.dvlaLookupQuestionMap.regQuestionId);
    let vehiclereg: string =
      this.permitQuestionsForm.value['vehicle_registration'];
    this.datastoreService.registration = vehiclereg
      .toLowerCase()
      .replace(/\s/g, '');
    try {
      const vehicleLookup: any = await this.apiService.getVehicleDetails(
        vehiclereg
      );

      if (vehicleLookup.error) {
        let indexOfErrorCode = vehicleLookup.message.indexOf(
          ' ',
          vehicleLookup.message.indexOf(':') + 1
        ); // get first : from the error string

        let statusCodeErrorMessage = vehicleLookup.message.substring(
          indexOfErrorCode + 1,
          indexOfErrorCode + 4
        );

        if (statusCodeErrorMessage == '404') {
          this.vehicleStatus = 2;
        } else {
          this.vehicleStatus = 3;
        }
        // } else if (vehicleLookup['result'].motStatus === "Not valid" || vehicleLookup['result'].taxStatus !== "Taxed") {
        //   if (vehicleLookup['result'].motStatus === "Not valid") {
        //     this.motStatusInvalid = true
        //   }
        //   if (vehicleLookup['result'].taxStatus !== "Taxed") {
        //     this.taxStatusInvalid = true
        //   }
      } else {

        const companyName = AppConfig.settings.apiServer.api_url
          .split('//')[1]
          .split('.council')[0];
        const reg: any = await this.amazonService.checkPermitApplicationOperation(
          this.parentDepartment.id,
          companyName,
          "",
          'checkDetail',
          "",
          "",
          "",
          "vehicle_registration",
          "",
          "",
          vehiclereg
        );
        if (reg.found) {
          this.registrationUsed = true
        } else {


          this.permitQuestionsForm.controls['vehicle_make'].setValue(
            vehicleLookup['result'].make
          );
          this.permitQuestionsForm.controls['vehicle_make'].patchValue(
            vehicleLookup['result'].make
          );

          // this.permitQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].disable()

          this.permitQuestionsForm.controls['vehicle_colour'].setValue(
            vehicleLookup['result'].colour
          );
          this.permitQuestionsForm.controls['vehicle_colour'].patchValue(
            vehicleLookup['result'].colour
          );
          // this.permitQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].disable()
          this.vehicleStatus = 1;
        }
      }
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.log(error);
    }
  }

  async checkVisitorAlertsTable(registration) {
    this.datastoreService.banned = false;
    this.datastoreService.observe = false;

    const res: any = await this.apiService.getAlertTableStatus(
      registration.replace(/\s/g, '').toUpperCase()
    );
    console.log(res);
    if (res) {
      console.log(res.hasOwnProperty('found'), res.found);
      if (res.hasOwnProperty('found')) {
        for (let find of res.found) {
          console.log(find);
          console.log(find.status === 'BANNED');
          if (find.status === 'BANNED') {
            this.datastoreService.banned = true;
          }
          if (find.status === 'OBSERVE') {
            this.datastoreService.observe = true;
          }
        }
      }
    }
  }

  async bannedRegistrationCheck(registration) {
    // Banned vehicle registrations from API
    // if (this.parentDepartment.extra.banned_vehicle_registration_numbers) {
    // If there are any banned vehicle registration numbers, run the check
    // var str = this.parentDepartment.extra.banned_vehicle_registration_numbers.replace(/\s/g, '').toLowerCase();
    // var banned = new Array();
    // banned = str.split(",");
    var banned: any = await this.apiService.getBanned();
    // Value to return
    // Check for match between banned registrations and users registration
    console.log(banned);
    if (banned.registrations) {
      for (let item of banned.registrations) {
        if (item.regno) {
          if (
            item.regno.replace(/\s/g, '').toLowerCase() ==
            registration.replace(/\s/g, '').toLowerCase()
          ) {
            return true;
          }
        } else {
          if (
            item.replace(/\s/g, '').toLowerCase() ==
            registration.replace(/\s/g, '').toLowerCase()
          ) {
            return true;
          }
        }
      }
      return false;
    } else {
      return false;
    }
  }

  formatPostcode() { }

  async ngOnInit() {
    this.permitQuestionsForm = this.formBuilder.group({});

    this.scrollToTop();

    this.availabilityService.getSelectedSlot().then((slot) => {
      if (slot) {
        this.slot = slot;
      }
    });

    this.parentDepartment = this.datastoreService.parentDepartment;

    if (!this.parentDepartment) {
      let parentDepartment = await this.departmentService.getParentDepartment();
      this.datastoreService.parentDepartment = parentDepartment;
      this.parentDepartment = this.datastoreService.parentDepartment;
      const pId = parentDepartment.id;
      const pClient = parentDepartment.self.split('://')[1].split('.')[0];
      const token: any = await this.apiService.getToken(pClient, pId);
      if (token) {
        environment.clientToken = token.token;
      }
    }
    this.spinner.show();
    this.selectedDepartment = this.datastoreService.selectedDepartment;
    let registrationOption = '';
    let organisationQuestionsID;
    await this.addressLookupStatusComponent.checkAddressLookupStatus(AppConfig, environment, this.datastoreService.config)

    // Set the title on the login page to the title from the business question
    this.parentDepartment.extra?.hasOwnProperty('booking_details_page_title')
      ? (this.pageTitle = this.parentDepartment.extra.permits_page_title)
      : (this.pageTitle = 'permits_page_title title not set');
    this.parentDepartment.extra?.hasOwnProperty('location_page_guidance_text')
      ? (this.guidanceMsg =
        this.parentDepartment.extra.permits_page_guidance_text)
      : (this.guidanceMsg = 'permits_page_guidance_text not set');

    //     // Use this.departmentService.getLocation() if the services are set on the children departments
    //     // Use this.departmentService.get() if the services are set on the parent department
    this.departmentService.get().then(async (location) => {
      this.selectedLocation = location;

      //     // Get the selected service
      this.servicesService.get().then(async (service) => {
        this.selectedService = service;

        // Get the questions
        console.log(this.parentDepartment);
        const schema_questions: any = await this.amazonService.getFormSchema(
          'hwrc_permits_application_form',
          this.parentDepartment.id,
          this.parentDepartment.self.split('//')[1].split('.council')[0]
        );
        console.log(schema_questions);
        let permitQuestions = [];
        for (const q of schema_questions.schema.fields) {
          q.id = q.field;
          q.name = q.title;
          q.help_text = q.helptext;
          q.detail_type = q.type;
          if (q.options) {
            for (let option of q.options) {
              option.id = option.value;
              option.name = option.title;
            }
          }
          if (q.radio_options) {
            q.options = q.radio_options;
            for (let option of q.options) {
              option.id = option.value;
              option.name = option.title;
            }
          }
          if (q.conditional) {
            q.settings = {
              conditional_question: q.trigger,
              conditional_answers: q.trigger_value,
            };
          }
          permitQuestions.push(q);
        }
        this.permitQuestions = permitQuestions;
        console.log(this.permitQuestions);

        for (let index = 0; index < permitQuestions.length; index++) {
          const question = permitQuestions[index];
          question.visible = false;
          question.reference = question.id;
          if (
            question.conditional === false ||
            question.conditional === undefined
          ) {
            question.visible = true;
          }
          const questionControl = question.id;
          if (question.id.includes('postcode')) {
            this.addresses[question.id] = [];
          }

          if (
            question.detail_type === 'date'
          ) {
            const validators = [];

            if (question.hasOwnProperty('minDate')) {
              validators.push(this.pastDateValidator(question.minDate, question.minDateValidation));
            }

            if (question.required) {
              validators.push(Validators.required);
            }

            this.permitQuestionsForm.addControl(
              questionControl,
              new BlFormControl('', validators)
            );
          }

          if (
            question.detail_type == 'check' ||
            question.detail_type == 'check-price'
          ) {
            if (question.required) {
              this.permitQuestionsForm.addControl(
                questionControl,
                new BlFormControl(false, Validators.requiredTrue)
              );
            } else {
              this.permitQuestionsForm.addControl(
                questionControl,
                new BlFormControl(false)
              );
            }
          } else {
            if (
              question.field.includes('email_address') &&
              !question.field.includes('do_you_have')
            ) {
              this.permitQuestionsForm.addControl(
                questionControl,
                new BlFormControl('', [
                  Validators.required,
                  Validators.email,
                ])
              );
            } else if (question.field.includes('contact_number')) {
              this.permitQuestionsForm.addControl(
                questionControl,
                new BlFormControl('', [
                  Validators.max(99999999999),
                ])
              );
            } else if (question.field.includes('postcode')) {
              this.permitQuestionsForm.addControl(
                questionControl,
                new BlFormControl('', [
                  Validators.required,
                  Validators.pattern(this.postcodeValidator),
                ])
              );
            } else if (question.required) {
              this.permitQuestionsForm.addControl(
                questionControl,
                new BlFormControl('', Validators.required)
              );
            } else {
              this.permitQuestionsForm.addControl(
                questionControl,
                new BlFormControl('')
              );
            }
          }
          if (
            this.permitQuestionsForm.controls[questionControl] &&
            question.editable === false
          ) {
            this.permitQuestionsForm.controls[questionControl].disable()
            this.permitQuestionsForm.controls[questionControl].alwaysDisabled = true;
            (
              this.permitQuestionsForm.get(questionControl) as BlFormControl
            ).alwaysDisabled = true;
          }
        }
        this.permitQuestionsForm.setValidators(
          this.matchingEmailsValidator(
            'email_address',
            'verify_email_address'
          )
        );
        this.spinner.hide();
      });
    });
  }

  repopulateQuestions() {
    this.permitQuestionsForm = this.datastoreService.bookingForm;
    this.vehicleStatus = 1;
    this.onQuestionChange();
  }

  onQuestionChange() {
    const permitQuestions = this.permitQuestions;
    // Conditional questions logic
    for (let index = 0; index < permitQuestions.length; index++) {
      const q = permitQuestions[index];
      // If the question has settings and relies on a conditional question
      if (q.settings && q.settings.hasOwnProperty('conditional_question')) {
        const conditionalQsArray = q.trigger.split('|');
        const conditionalAsArray = q.trigger_value.split('|');
        let visible = false;
        for (let i in conditionalQsArray) {
          // Get the conditional question based on the id set in q
          const conditionalQ = permitQuestions.find((question) => {
            return question.id == conditionalQsArray[i];
          });
          // Get the question control
          const questionControl =
            this.permitQuestionsForm.controls[conditionalQsArray[i]];
          // If the question control has a value get the option from the contional question. This will allow
          // us to check if q is shown when value is selected
          if (conditionalQ && conditionalQ.hasOwnProperty('options')) {
            const option = conditionalQ.options.find(
              (option) => option.name == questionControl.value
            );
            // If the conditional question is visible and the value chosen === to qs conditional answer then show q
            if (conditionalQ) {
              if (
                conditionalQ.visible &&
                option &&
                conditionalAsArray[i] === option.value
              ) {
                // If the condiditonal question is important, Hide it
                visible = true;
              }
            } else {
              if (
                conditionalQ.value === conditionalAsArray[i] &&
                conditionalQ.visible
              ) {
                visible = true;
              }
            }
          }
        }
        if (visible) {
          q.visible = true;

          if (
            this.permitQuestionsForm.controls[q.id]['alwaysDisabled'] != true
          ) {
            this.permitQuestionsForm.controls[q.id].enable();
          }
        } else {
          q.visible = false;
          this.permitQuestionsForm.controls[q.id].setValue('');
          this.permitQuestionsForm.controls[q.id].disable();
        }
      }
    }
    if (this.permitQuestionsForm.controls["what_type_of_permit_do_you_require"]) {
      if (this.permitQuestionsForm.controls["is_this_a_hire_vehicle"].value === "Yes" && this.permitQuestionsForm.controls["what_type_of_permit_do_you_require"].value === "Annual Permit") {
        this.permitQuestionsForm.controls["what_type_of_permit_do_you_require"].setValue("");
        this.permitQuestionsForm.controls["what_type_of_permit_do_you_require"].patchValue("");
      }
    }
  }

  // validate past dates
  pastDateValidator(date: string, minDateValidation: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control?.value;
      if (!value) return null;

      const inputDate = moment(value).startOf('day');
      const referenceDate = date === 'today'
        ? moment().startOf('day')
        : moment(date).startOf('day');

      return inputDate.isBefore(referenceDate)
        ? { pastDate: { message: minDateValidation } }
        : null;
    };
  }

  onFileChange(event, questionId) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.permitQuestionsForm.patchValue({
        fileSource: file,
      });
    }
  }

  async getAddress(id) {
    try {
      console.log("id", id)
      this.showingAddresses[id] = false;

      // Clear the addresses array
      this.addresses[id] = [];
      this.permitQuestionsForm.controls[
        id.replace('postcode', 'address')
      ].setValue('');

      // Custom error handling for postcode
      let postcode: String = this.permitQuestionsForm.value[id].replace(
        /\s/g,
        ''
      );
      this.permitQuestionsForm.controls[id].setValue(postcode);
      if (this.permitQuestionsForm.controls[id].status == 'INVALID') {
        this.permitQuestionsForm.get('postcode').setErrors({
          invalidPostcode: this.translateService.instant(
            'COMMON.INVALID_POSTCODE'
          ),
        });
        return;
      }
      this.spinner.show();
      const res = await this.amazonService.osGetNameDataEncodedApi(
        this.permitQuestionsForm.value[id]
      );
      if (
        this.permitQuestionsForm.controls[id].errors &&
        this.permitQuestionsForm.controls[id].errors.invalidPostcode
      ) {
        delete this.permitQuestionsForm.controls[id].errors.invalidPostcode;
      }
      var object: any = res;
      if (object.results) {
        if (
          this.permitQuestionsForm.controls[id].errors &&
          this.permitQuestionsForm.controls[id].errors.addressNotFound
        ) {
          delete this.permitQuestionsForm.controls[id].errors.addressNotFound;
        }
        var addresses = object.results;

        const addressesExist = addresses.filter((e) => {
          if (e.DPA) {
            return true;
          } else if (e.LPI) {
            return true;
          }
        });

        const addressException = await this.apiService.getAddressException();
        let expections = [];

        if (addressException) {
          expections = addressException['Items'];
        }

        let added = [];
        if (addressesExist.length > 1) {
          let localCodes = [];
          addressesExist.forEach((item) => {
            const expectionAddress = expections.find(({ UPRN }) => {
              if (item.DPA) {
                if (UPRN === item.DPA.UPRN) {
                  return true;
                }
              }
              if (item.LPI) {
                if (UPRN === item.LPI.UPRN) {
                  return true;
                }
              }

              return false;
            });

            const addedAlready = added.find(({ ADDRESS }) => {
              if (item.DPA) {
                if (ADDRESS === item.DPA.ADDRESS) {
                  return true;
                }
              }
              if (item.LPI) {
                if (ADDRESS === item.LPI.ADDRESS) {
                  return true;
                }
              }

              return false;
            });

            let alreadyEntered = false;

            if (expectionAddress === undefined) {
              alreadyEntered = this.addresses[id].some((e) => {
                if (item.DPA && item.DPA.UPRN === e.address.UPRN) {
                  return true;
                } else if (item.LPI && item.LPI.UPRN === e.address.UPRN) {
                  return true;
                }
              });
            }

            if (!alreadyEntered && addedAlready === undefined) {
              if (item.DPA) {
                this.addresses[id].push({ address: item.DPA });
                added.push({ ADDRESS: item.DPA.ADDRESS });
                const inLocalArea = this.checkAddress(item.DPA, id);
                if (inLocalArea) {
                  localCodes.push(inLocalArea);
                }
              } else {
                this.addresses[id].push({ address: item.LPI });
                added.push({ ADDRESS: item.LPI.ADDRESS });
                const inLocalArea = this.checkAddress(item.LPI, id);
                if (inLocalArea) {
                  localCodes.push(inLocalArea);
                }
              }
            }
          });

          // if (repopulate) {
          //   let selectedAddress =
          //     this.permitQuestionsForm.controls.selectedAddress.value.address.ADDRESS;
          //   for (let i = 0; i < this.addresses.length; i++) {
          //     let item = this.addresses[i];
          //     if (selectedAddress == item.address.ADDRESS) {
          //       this.selectedAddressId = i;
          //     }
          //   }
          // }

          this.addresses[id] = this.addresses[id].filter(
            (x) =>
              x.address.CLASSIFICATION_CODE[0] === 'R' ||
              x.address.CLASSIFICATION_CODE[0] === 'P' ||
              x.address.CLASSIFICATION_CODE[0] === 'PP' ||
              x.address.CLASSIFICATION_CODE[0] === 'C'
          );
          if (this.addresses[id].length === 0) {
            this.permitQuestionsForm.get('postcode').setErrors({
              addressNotFound: this.translateService.instant(
                'COMMON.ADDRESS_NOT_FOUND_RES'
              ),
            });
            this.spinner.hide();
          } else {
            this.showingAddresses[id] = true;

            this.isInLocalArea[id] = localCodes.length > 0;
            this.localAreaId = id
            this.onQuestionChange()
          }
          // } else {
          //   this.showingAddresses[id] = true;
          //   this.isInLocalArea[id] = false;
          // }
        } else {
          // If it doesn't match up, show an error message
          console.log('dsd', addressesExist);
          this.permitQuestionsForm.get('postcode').setErrors({
            invalidPostcode: this.translateService.instant(
              'COMMON.ADDRESS_NOT_ELIGIBLE'
            ),
          });
        }
      } else {
        this.permitQuestionsForm.get('postcode').setErrors({
          addressNotFound: this.translateService.instant(
            'COMMON.ADDRESS_NOT_FOUND'
          ),
        });
      }
      this.spinner.hide();
    } catch (error) {
      console.log(error);
      await this.addressLookupStatusComponent.checkAddressLookupStatus(AppConfig, environment, this.datastoreService.config)
      this.spinner.hide();
    }
  }


  async getAddressDorset(id, repopulate: any = null) {
    this.spinner.show()
    this.showingAddresses[id] = false;

    // Clear the addresses array
    this.addresses.length = 0;
    this.permitQuestionsForm.controls[
      id.replace('postcode', 'address')
    ].setValue('');

    // Custom error handling for postcode
    let postcode: String = this.permitQuestionsForm.value.postcode.replace(/\s/g, '');
    this.permitQuestionsForm.controls.postcode.setValue(postcode);
    if (this.permitQuestionsForm.controls.postcode.status == 'INVALID') {
      this.permitQuestionsForm.get('postcode').setErrors({
        invalidPostcode: this.translateService.instant(
          'COMMON.INVALID_POSTCODE'
        ),
      });
      return;
    }
    const allUk: any = await this.apiService.searchArea(postcode, "uk")
    if (allUk.length === 0) {
      this.permitQuestionsForm.get('postcode').setErrors({
        addressNotFound: this.translateService.instant(
          'COMMON.ADDRESS_NOT_FOUND_RES'
        ),
      });
    } else {

      this.addresses[id] = allUk
      console.log("allUk", allUk)
      if (repopulate) {
        let selectedAddress =
          repopulate
        for (let i = 0; i < this.addresses[id].length; i++) {
          let item = this.addresses[id][i];
          console.log(selectedAddress, selectedAddress == item.address.ADDRESS, item.address.ADDRESS,)
          if (selectedAddress.address.ADDRESS == item.address.ADDRESS) {
            this.selectedAddressId = i;
            this.permitQuestionsForm.controls[
              'address'
            ].setValue(item);
          }
        }
      }

      const justDorset: any = await this.apiService.searchArea(postcode, "dorset")

      this.showingAddresses[id] = true;
      this.localAreaId = id

      this.isInLocalArea[id] = justDorset.length > 0;
    }

    this.spinner.hide()
  }

  uploadTest(field: any, event: Event) {
    const target: HTMLInputElement = event.target as HTMLInputElement;
    console.log(target.files);
    for (const file of Array.from(target.files!)) {
      let reader = new FileReader();

      console.log(file);

      reader.onload = async (e: any) => {
        console.log(e.target);
        if (!this.uploadQuestionFiles[field.id]) {
          this.uploadQuestionFiles[field.id] = [];
          this.uploadQuestionIds.push(field.id);
        }
        console.log(this.uploadQuestionFiles);
        this.uploadQuestionFiles[field.id].push(
          this.formBuilder.group({
            file,
            url: e.target.result, //Base64 string for preview image
          })
        );
        this.permitQuestionsForm.controls[field.id].setValue('placeHolder');
      };
      reader.readAsDataURL(file);
      // target.value = '-';
    }
  }

  async removeFileAtIndex(field: any, i: number, event: Event) {
    event.preventDefault();
    this.uploadQuestionFiles[field.id].splice(i, 1);
    if (this.uploadQuestionFiles[field.id].length === 0) {
      this.permitQuestionsForm.controls[field.id].setValue('');
    }
    console.log(this.uploadQuestionFiles);
    console.log(this.uploadQuestionIds);
  }

  async onSubmit() {
    this.spinner.show();
    this.submitted = true;
    this.alertService.clear();
    console.log(this.permitQuestionsForm, this.addressUsed, this.registrationUsed);
    // Check if form is valid
    if (this.permitQuestionsForm.invalid || this.addressUsed || this.registrationUsed) {
      this.spinner.hide();
      if (this.permitQuestionsForm.invalid) {
        this.focusFirstInvalidControl(this.permitQuestionsForm);
      }
      return;
    }

    // for some reason this function sometimes doesn't get run, adding the console logs fixed this (not sure why)

    this.completeBooking();
  }

  async completeBooking() {
    await this.completeDetails();
  }

  async completeDetails() {
    // // Use email/phone to check if the user is banned
    // let res = await this.apiService.checkEmailNumber(email, null, this.selectedDepartment);

    // let checkAccount = new Promise((resolve, reject) => {
    //   if (res == undefined) {
    //     resolve("finished")
    //   }
    //   if (res["_source"] && res["_source"].questions) {
    //     if (res["_source"].questions.length > 0) {
    //       res["_source"].questions.forEach((question, index) => {
    //         if (question.id == 8 && question.answer == "1") {
    //           reject("banned")
    //           this.banned = true;
    //           return;
    //         }
    //         if (index === res["_source"].questions.length - 1) {
    //           resolve("finished");
    //         }
    //       });
    //     } else {
    //       resolve("finished");
    //     }
    //   } else {
    //     resolve("finished");
    //   }
    // });

    console.log(this.uploadQuestionFiles);
    console.log(this.uploadQuestionIds);
    for (let id of this.uploadQuestionIds) {
      console.log(id);
      if (this.permitQuestionsForm.controls[id].status == 'VALID') {
        const fileIds = [];
        for (let myFile of this.uploadQuestionFiles[id]) {
          console.log(myFile);
          const nameParts = myFile.value.file.name.split('.');
          const d: any = await this.amazonService.uploadFile({
            data: myFile.value.url,
            type: myFile.value.file.type,
            workflow: '',
            original_file_name: `${myFile.value.file.name}`,
            ext: `${nameParts[nameParts.length - 1]}`,
          });
          console.log(d);
          fileIds.push({
            id: d.file,
            fileName: `${myFile.value.file.name}`,
            fileSize: `${(myFile.value.file.size / (1024 * 1024)).toFixed(
              3
            )}MB`,
          });
        }
        this.permitQuestionsForm.controls[id].setValue(fileIds);
      }
    }
    let annual_allowance = 12;
    let day_allowance = 0;
    // const permitTypeQuestion = this.permitQuestions.find(
    //   (x) => x.id === 'what_type_of_permit_do_you_require'
    // );
    // if (
    //   this.permitQuestionsForm.controls['what_type_of_permit_do_you_require']
    //     .value ===
    //   permitTypeQuestion.options.find((x) => x.id === 'annual_permit').title
    // ) {
    //   annual_allowance = 12;
    // }
    // console.log(
    //   this.permitQuestionsForm.controls['what_type_of_permit_do_you_require']
    //     .value,
    //   permitTypeQuestion.options.find((x) => x.id === '1_day_hire_permit').title
    // );
    // if (
    //   this.permitQuestionsForm.controls['what_type_of_permit_do_you_require']
    //     .value ===
    //   permitTypeQuestion.options.find((x) => x.id === '1_day_hire_permit').title
    // ) {
    //   day_allowance = 1;
    // }
    // if (annual_allowance === 0 && day_allowance === 0) {
    //   this.alertService.warn("annual_allowance === 0 && day_allowance === 0. This should not be possible. Contact support")
    //   this.scrollToTop();
    //   return
    // }

    // checkAccount.then(async () => {
    const data: any = {};
    console.log(this.permitQuestionsForm);
    console.log(this.permitQuestions);
    const companyName = AppConfig.settings.apiServer.api_url
      .split('//')[1]
      .split('.council')[0];

    let value = {}
    for (let control in this.permitQuestionsForm.controls) {
      value[control] = this.permitQuestionsForm.controls[control].value
    }
    console.log(value)
    console.log(this.permitQuestionsForm.value)
    const valid_from = moment().startOf("day").format()
    const valid_to = moment().startOf("day").add(1, 'year').subtract(1, 'second').format()
    const putPermit: any =
      await this.amazonService.putPermitApplicationOperation(
        value,
        this.parentDepartment.id,
        companyName,
        'put',
        annual_allowance,
        day_allowance,
        valid_from,
        valid_to,
        2,
        "New"
      );
    console.log(putPermit);

    await this.emailBodyMaker(putPermit?.permit_id, annual_allowance, valid_from, valid_to);
    this.spinner.hide();

    // var currentSlot = new Date(this.slot.datetime).toTimeString();

    // let canContinue = true;
    // this.unavailableTimes.forEach(bookedSlot => {
    //   if (currentSlot.includes(bookedSlot)) {
    //     // if the current slot matches an unavailable time, +1 to can continue (doing it like this so it doesn't break the loop)
    //     canContinue = (false)
    //   }
    // });
    // If canContinue = (there is a match between current slot and unavailable time), then show error, otherwise continue
    // if (!canContinue) {
    //   this.alertService.error(
    //     this.translateService.instant('COMMON.BACK_TO_BACK_BOOKINGS')
    //   );
    //   this.scrollToTop();
    //   this.spinner.hide();
    //   return;
    // } else {
    this.router.navigate(['/permits-submitted']);
    // }
    // }).catch((e) => {
    //   console.log("ERROR", e);
    //   if (e == "banned") {
    //     this.alertService.warn(this.translateService.instant('COMMON.USER_BANNED'));
    //   } else {
    //     this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'));
    //   }
    //   this.scrollToTop();
    //   this.spinner.hide();
    // });
  }

  async emailBodyMaker(permit, annual_allowance, valid_from, valid_to) {
    console.log(this.datastoreService.config);
    let clientEmail = this.permitQuestionsForm.controls.email_address.value;
    if (!clientEmail) clientEmail = '-';
    let vehicle_registration = this.permitQuestionsForm.controls.vehicle_registration.value;
    if (!vehicle_registration) {
      vehicle_registration = this.permitQuestionsForm.controls.manual_vehicle_registration.value;
      if (!vehicle_registration) {
        vehicle_registration = '-';
      }
    }
    let address = this.permitQuestionsForm.controls.address.value.address.ADDRESS
    if (!address) address = '-';
    let clientPhone = this.permitQuestionsForm.controls?.contact_number?.value;
    if (!clientPhone) clientPhone = '-';
    let clientName = `${this.permitQuestionsForm.controls?.first_name?.value} ${this.permitQuestionsForm.controls?.last_name?.value}`;
    if (!this.permitQuestionsForm.controls?.first_name?.value) clientEmail = '-';
    let variables = [
      { find: 'date', replace: moment().format("dddd Do MMMM YYYY") },
      { find: 'permit', replace: permit },
      { find: 'permit_id', replace: permit },
      { find: 'what_type_of_permit_do_you_require', replace: 'unasked question!' },
      { find: 'which_HWRC_site_do_you_require_your_permit_for', replace: 'unasked question!' },
      { find: 'name', replace: clientName },
      { find: 'email', replace: clientEmail },
      { find: 'contact_number', replace: clientPhone },
      { find: 'vehicle_registration', replace: vehicle_registration },
      { find: 'address', replace: address },
      { find: 'annual_allowance', replace: annual_allowance },
      { find: 'permit_start_date', replace: moment(valid_from, "YYYY-MM-DD").format("dddd Do MMMM YYYY") },
      { find: 'permit_expiry_date', replace: moment(valid_to, "YYYY-MM-DD").format("dddd Do MMMM YYYY") },
    ];

    const body = {
      emailTemplate: 'annual-permit-application-approved.html',
      variables: JSON.stringify(variables),
      email: clientEmail,
      subject: 'Recycling Centre - Permit Application Approved',
    };

    await this.amazonService.emailTemplateSender(body);
  }

  // Scroll to the top of the page
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }

  // Number input text validation, keycode 8 is backspace
  keyPressNumberField(event: any, field) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    } else {
      console.log(this.permitQuestionsForm);
      console.log(field);
      const newString = `${this.permitQuestionsForm.value[field]}`;
      console.log(newString);
      this.permitQuestionsForm.controls[field].setValue(
        newString.substring(0, 10)
      );
    }
  }

  canAnnualPermit(value) {
    if (this.permitQuestionsForm.controls["is_this_a_hire_vehicle"].value === "Yes") {
      if (value === "Annual Permit") {
        return false
      }
    }
    return true
  }

  async checkAddressExistingPermit(field) {
    this.addressUsed = false
    let address = this.permitQuestionsForm.value[field]
    if (address?.address.ADDRESS) {
      this.spinner.show()

      console.log("address", address.address)
      console.log("address", address.address)
      const companyName = AppConfig.settings.apiServer.api_url
        .split('//')[1]
        .split('.council')[0];
      const reg: any = await this.amazonService.checkPermitApplicationOperation(
        this.parentDepartment.id,
        companyName,
        "",
        'checkDetail',
        "",
        "",
        "",
        "address",
        "address",
        "ADDRESS",
        address.address.ADDRESS
      );
      if (reg.found) {
        this.addressUsed = true
      }
      this.spinner.hide()
    }
  }

  checkIfDisable() {
    let disable = false
    // console.log(this.permitQuestions)
    const vinA = this.permitQuestions.find((x) => x.field === 'vehicle_is_not_allowed')
    if (vinA) {
      if (vinA.visible) {
        disable = true
      }
    }
    return disable
  }

  async hardCodedRules(question) {
    console.log("changed", question)
    if (question.field === "manual_vehicle_registration") {
      this.spinner.show()
      this.registrationUsed = false
      const companyName = AppConfig.settings.apiServer.api_url
        .split('//')[1]
        .split('.council')[0];
      const reg: any = await this.amazonService.checkPermitApplicationOperation(
        this.parentDepartment.id,
        companyName,
        "",
        'checkDetail',
        "",
        "",
        "",
        "vehicle_registration",
        "",
        "",
        this.permitQuestionsForm.controls[question.field].value
      );
      console.log("value", this.permitQuestionsForm.controls[question.field].value)
      console.log("value", reg)
      if (reg.found) {
        this.registrationUsed = true
      }
      this.spinner.hide()
    }
  }

  focusFirstInvalidControl(form: FormGroup): void {
    const invalidControl = this.findInvalidControl(form);
    if (invalidControl) {
      invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });

      if (invalidControl.tagName.toLowerCase() === 'mat-radio-group') {
        const firstRadioInput = invalidControl.querySelector(
          'input[type="radio"]'
        ) as HTMLElement | null;

        if (firstRadioInput) {
          firstRadioInput.focus({ preventScroll: true });
          return;
        }
      }
      invalidControl.focus?.({ preventScroll: true });
    }
  }

  private findInvalidControl(form: FormGroup): HTMLElement | null {
    const invalidControlName = Object.keys(form.controls).find(
      (key) => form.controls[key].invalid
    );

    if (!invalidControlName) return null;

    const invalidControl = document.querySelector(
      `[id="${invalidControlName}"]`
    );
    return invalidControl as HTMLElement | null;
  }
}